module.exports = __webpack_public_path__ + "img/Troll_duel-Roberto-Pitturru.56a86c8f.jpg";